var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-layout',[_c('div',{staticClass:"fill-height",staticStyle:{"max-width":"100%","position":"relative"},attrs:{"fill-height":""}},[_c('v-card-title',{staticClass:"m-page__title"},[_c('span',{staticClass:"headline"},[_vm._v("Help")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }